var poll_default = {
  "fontElementMap": "_5-m-F",
  "container": "mC6oo",
  "fullscreen": "WyLfU",
  "background_overlay": "fwtAH",
  "with_image": "pJLdX",
  "options": "bTH9K",
  "webview": "AE76E",
  "grid": "rQFKu",
  "option": "t31wa",
  "cta_button": "NSepA",
  "add_option": "_5Tp2h",
  "see_more": "bJGcZ",
  "list": "HsbMe",
  "column": "ZIGwA",
  "additional_note": "_4En4p",
  "spinner": "Jc7Ic",
  "spin": "-jThb",
  "shown": "rzi29",
  "error": "Fooek"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
